import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadValuepropositionPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'バリュープロポジション フレームワーク デザイン デザイン思考'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/value-proposition/done/'}
          title="ご入力いただきありがとうございます | バリュープロポジションキャンバス | 資料ダウンロード | Aitria（アイトリア）"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
